import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { loggedIn } from 'src/utils/user';
import Layout from 'src/components/Layout';
import LoginForm from 'src/components/Authentication/LoginForm';

const IndexPage = (): JSX.Element => (
  <Layout>
    <LoginForm />
  </Layout>
);

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  if (loggedIn(context)) {
    return {
      redirect: {
        destination: '/home',
        permanent: false,
      },
    };
  }

  return {
    props: {
      messages: {
        ...require(`src/messages/article/${context.locale}.json`),
        ...require(`src/messages/auth/${context.locale}.json`),
      },
    },
  };
};

export default IndexPage;
